import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopOnDutyChangeOk(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} popSize="xs" type="com_input pop_duty_change">
      <h2 className="pop_tit">당직자 변경 승인</h2>
      <div className="content_container scroll mb_no">
        <div className="pop_cont">
          <strong>홍길동123님</strong>이 &gt;&gt;
          <strong className="com_blue_txt">최영희789님</strong>으로 당직자 변경을 요청했습니다.
        </div>
        <ul className="com_input_sec">
          <li className="input_field">
            <div className="check center">
              <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
              <label htmlFor="rdo01">승인</label>
              <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
              <label htmlFor="rdo02">승인불가</label>
            </div>
          </li>
          <li>
            <div className="info_txt">
              변경자 본인만 승인 할 수 있습니다.
              <br /> 승인 하시면 해당일에 당직자가 됩니다.
            </div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopOnDutyChangeOk;
